import React from 'react'

const NextSection = ({ section }) => {
  return (
    <a href={section} className='sm:next-section-button'>
    </a>
  )
}

export default NextSection